import { Store } from 'libx'
import { browserHistory } from 'react-router'
import { observable, computed, action, runInAction } from 'mobx'
import links from '../../misc/links'

export default class RateProjectStore extends Store {
  @observable project = null
  @observable loading = false
  @observable disabled = false
  @observable rating = 5
  @observable comment = ''
  @observable selectedCategories = []

  @computed get hasRated () {
    return this.rating > 0
  }

  @computed get categoriesPromptText () {
    if (this.rating <= 3) return 'What went wrong?'
    if (this.rating <= 4) return 'What went well?'
    return 'What was awesome?'
  }

  @computed get canSubmit () {
    return this.hasRated
  }

  categorySelected (key) {
    return this.selectedCategories.indexOf(key) > -1
  }

  @action rate (rating) {
    this.rating = rating
  }

  @action toggleRatingCategory (key) {
    const selected = this.categorySelected(key)
    if (selected) {
      this.selectedCategories.remove(key)
    } else {
      this.selectedCategories.push(key)
    }
  }

  @action changeComment (comment) {
    this.comment = comment
  }

  async activate (projectId) {
    runInAction(() => {
      this.rating = 5
      this.comment = ''
      this.selectedCategories = []
      this.loading = true
    })
    try {
      const project = await this.rootStore.projectStore.fetchProject(projectId)
      if (!project.completed || project.partnerRating) {
        // Project either not completed, or we already have a rating for it.
        browserHistory.replace(links.projectDetails(project.id))
        return
      }
      runInAction(() => {
        this.project = project
      })
    } finally {
      runInAction(() => {
        this.loading = false
      })
    }
  }

  async ensureAllRated () {
    await this.rootStore.projectStore.fetchProjects()
    const projects = this.rootStore.projectStore.projects.map(x => x)
    const unrated = projects.filter(x => x.completed && !x.partnerRating)
    const [first] = unrated
    if (first) {
      browserHistory.push(links.rateProject(first.id))
    }
  }

  async submit () {
    runInAction(() => {
      this.disabled = true
    })

    try {
      await this.rootStore.projectStore.rate(this.project, {
        rating_submitted: this.rating,
        rating_submitted_comment: this.comment,
        rating_submitted_categories: this.selectedCategories
      })
      runInAction(() => {
        browserHistory.replace(links.projectDetails(this.project.id))
      })
    } finally {
      runInAction(() => {
        this.disabled = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/RateProjectStore.js